var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXNeutral = function SvgXNeutral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M21 41c11.046 0 20-8.954 20-20S32.046 1 21 1 1 9.954 1 21s8.954 20 20 20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.68 9.412 9.56 12.782-9.62 10.393h2.164l8.423-9.1 6.805 9.1h7.368L23.282 19.086l8.954-9.674h-2.165l-7.757 8.38-6.267-8.38zm3.184 1.595h3.384l14.947 19.985H26.81z"
  })));
};
export { SvgXNeutral as ReactComponent };